import { Tabs, Row } from "antd";
import React, { useState, memo } from "react";

const { TabPane } = Tabs;

const QaTab = ({ form, renderItems, canRenderTab }) => {
    const [selectedTab, setSelectedTab] = useState(`tab-${form.attributes["@codigo"]}-0`);

    const isToForceRender = form.attributes["@nome"] === "orbis_mov_lancamentos_condominios.xml";

    return (
        <Tabs
            defaultActiveKey={selectedTab}
            onChange={(key) => {
                setSelectedTab(key);
            }}
            style={{ width: "100%" }}
        >
            {form.tabs
                .map((tab, index) => ({
                    tab,
                    render: canRenderTab({ tabInputKeys: form.fields["tab" + index], formInputs: form.inputs }),
                    index,
                }))
                .filter((tab) => tab.render)
                .map(({ tab, index }) => (
                    <TabPane tab={tab} key={`tab-${form.attributes["@codigo"]}-${index}`} forceRender={isToForceRender}>
                        <Row gutter={18} type="flex" align="middle">
                            {form &&
                                renderItems({
                                    arrayFields: form.fields["tab" + index],
                                    objectInputs: form.inputs,
                                })}
                        </Row>
                    </TabPane>
                ))}
        </Tabs>
    );
};

export default memo(QaTab);
